module.exports = __webpack_public_path__ + "img/download.602c29e6.svg";